import { useState, useEffect, useCallback } from "react";
import { airspacesApi, dronesApi } from "../../api/api";

export const useAtsMapData = (user) => {
  const [data, setData] = useState({});

  const fetchData = useCallback(async () => {
    if (!user?.atsIcaoLocationIndicator) return;
    try {
      const [ctrsRes, restrictedAreasRes, bufferZonesRes, futureObjectsRes, trafficInformationZonesRes, airTrafficZonesRes, restrictedAreasTemporaryRes, uasZonesRes, dronesRes] = await Promise.all([
        airspacesApi.getCtr(),
        airspacesApi.getRestrictedAreas(),
        airspacesApi.getBufferZones(),
        airspacesApi.getFutureObjects(),
        airspacesApi.getTrafficInformationZones(),
        airspacesApi.getAirTrafficZones(),
        airspacesApi.getRestrictedAreasTemporary(),
        airspacesApi.getUasZones(),
        dronesApi.get(user.atsIcaoLocationIndicator, user.atsLat, user.atsLng),
      ]);
      setData({
        ctrAirspaces: ctrsRes.data || [],
        restrictedAreasAirspaces: restrictedAreasRes.data || [],
        bufferZonesAirspaces: bufferZonesRes.data || [],
        futureObjectsAirspaces: futureObjectsRes.data || [],
        trafficInformationZonesAirspaces: trafficInformationZonesRes.data || [],
        airTrafficZonesAirspaces: airTrafficZonesRes.data || [],
        restrictedAreasTemporaryAirspaces: restrictedAreasTemporaryRes.data || [],
        uasZonesAirspaces: uasZonesRes.data || [],
        drones: dronesRes.data || [],
      });
    } catch (err) {
      console.error(err);
    }
  }, [user?.atsIcaoLocationIndicator, user?.atsLat, user?.atsLng]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 300000);
    return () => clearInterval(interval);
  }, [fetchData]);

  return { data };
};
